'use strict';
(function(angular) {
  angular.module('activationApp')
    .directive('ftActivationProgress', function() {
      return {
        restrict: 'EA',
        replace: true,
        templateUrl: 'views/activation/activation-progress.html',
        scope: {
          currentStep: '='
        },
        controller: [
          '$scope',
          function(
            $scope,
          ) {
            $scope.isActive = function(stepNumber) {
              return (stepNumber === $scope.currentStep);
            };

            $scope.isPast = function(stepNumber) {
              return (stepNumber < $scope.currentStep);
            };
          }]
      };
    });
})(angular);

